import {CSSProperties, FC} from 'react';


export interface IIconUserProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconUser: FC<IIconUserProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M18 20h-1.5v-1.524c0-1.262-1.007-2.285-2.25-2.285h-4.5c-1.243 0-2.25 1.023-2.25 2.285V20H6v-1.524c0-2.104 1.679-3.81 3.75-3.81h4.5c2.071 0 3.75 1.706 3.75 3.81V20Zm-6-6.857a4.488 4.488 0 0 1-3.897-2.286 4.634 4.634 0 0 1 0-4.571A4.488 4.488 0 0 1 12 4c2.485 0 4.5 2.047 4.5 4.571 0 2.525-2.015 4.572-4.5 4.572Zm0-1.524c1.657 0 3-1.364 3-3.048 0-1.683-1.343-3.047-3-3.047S9 6.888 9 8.57c0 1.684 1.343 3.048 3 3.048Z" clipRule="evenodd" />
        </svg>
    );
};
